import { getSearchLink } from "@Pages/Search/data/helper";
import config from "@Config/index";
import { CANNIBALIZATION_ROLLOUT } from "constants/configConstants";

const REGION_WORDS: any = {
  "United States": "Housing",
  Canada: "Housing",
};

export const getHeadingText = (region: any, t: any) => {
  const isEstablishmentInUSA =
    region?.region_type === "establishment" && region?.root_name === "United States";

  if (config.IS_CHINA_APP) {
    return t("searchpage.searchheading.studentaccomodationin");
  }

  if (isEstablishmentInUSA) {
    return t("Apartments near");
  }

  const accommodationType = t(REGION_WORDS[region?.root_name]) || t("Accommodations");
  const preposition =
    region?.region_type === "establishment" || region?.region_type === "sublocality"
      ? t("near")
      : t("in");

  return `${t("Student")} ${accommodationType} ${preposition}`;
};

export const getRegionBreadcrumb = (region: any, options: any = {}, countryCode?: string) => {
  const breadcrumb = [];
  // cannibalization check: Include Home as the first breadcrumb item
  if (CANNIBALIZATION_ROLLOUT.includes(countryCode || "")) {
    breadcrumb.push({ name: "Home", link: "/" });
  }
  if (options.root) {
    breadcrumb.push({ name: "All Countries", link: "/" });
  }
  if (region && (region?.ancestors || region?.ancestors_short)) {
    const types = CANNIBALIZATION_ROLLOUT.includes(countryCode || "")
      ? ["country", "locality"]
      : ["country", "state", "locality", "sublocality"];
    types.forEach((region_type) => {
      (region?.ancestors || region?.ancestors_short).forEach((element: any) => {
        if (element.region_type == region_type) {
          breadcrumb.push({
            link: getSearchLink(element.canonical_name),
            name: element.name,
          });
        }
      });
    });
  }
  // Include parent
  if (region && options.parent) {
    breadcrumb.push({
      link: getSearchLink(region.canonical_name),
      name: region.name,
    });
  }
  // Include parent if region is locality/country/state (and establishment/sublocality only for AU)
  const isAU = CANNIBALIZATION_ROLLOUT.includes(countryCode || "");
  const allowedTypes = isAU
    ? ["country", "state", "locality", "establishment", "sublocality"]
    : ["country", "state", "locality"];

  if (region && options.parent_1 && allowedTypes.includes(region.region_type)) {
    breadcrumb.push({
      link: getSearchLink(region.canonical_name),
      name: region.name,
    });
  }
  return breadcrumb;
};

export default REGION_WORDS;
